import { createAction, props } from '@ngrx/store';
import { Group, GroupsListMeta, GroupSubmitPayload } from '../models/group.model';
import { ApiTableFilter } from '../../../shared/models/table-filter.model';

export const loadGroups = createAction(
  '[Groups] Load Groups',
  props<{
    page?: number;
    perPage?: number;
    search?: string;
    sort?: string;
    sortDirection?: string;
    filters?: ApiTableFilter[];
    filterLink?: string;
  }>()
);
export const loadGroupsSuccess = createAction(
  '[Groups] Load Groups Success',
  props<{ groups: Group[]; meta: GroupsListMeta }>()
);
export const loadGroupsFailure = createAction(
  '[Groups] Load Groups Failure',
  props<{ error: string }>()
);

export const submitGroup = createAction(
  '[Groups] Submit Group',
  props<{ payload: GroupSubmitPayload; isEditMode: boolean }>()
);
export const submitGroupSuccess = createAction('[Groups] Submit Group Success');
export const submitGroupFailure = createAction(
  '[Groups] Submit Group Failure',
  props<{ error: string }>()
);

export const deleteGroup = createAction(
  '[Groups] Delete Group',
  props<{ groupId: string }>()
);
export const deleteGroupSuccess = createAction('[Groups] Delete Group Success');
export const deleteGroupFailure = createAction(
  '[Groups] Delete Group Failure',
  props<{ error: string }>()
);

export const bulkDeleteGroups = createAction(
  '[Groups] Bulk Delete Groups',
  props<{ uuids: string[]; allSelected: boolean }>()
);
export const bulkDeleteGroupsSuccess = createAction(
  '[Groups] Bulk Delete Groups Success'
);
export const bulkDeleteGroupsFailure = createAction(
  '[Groups] Bulk Delete Groups Failure',
  props<{ error: string }>()
);

export const resetGroupsState = createAction('[Groups] Reset State');
